<template>
  <ec-flex vertical full class="fb-container" :vGap="0" alignItems="stretch">
    <ec-flex full alignItems="center" v-if="title.length > 0" class="fb-title-container" :style="titleStyle">
      <div class="fb-title flex-row-nowrap-start-start-center">{{ title }}</div>
      <slot name="titleSuffix"></slot>
      <div class="flex-grow-1"></div>
      <slot name="action"></slot>
      <ec-icon v-if="collapsible" :name="isCollapsed ? 'common/arrow-up' : 'common/arrow-down'" size="16" @click="toggleCollapse"></ec-icon>
    </ec-flex>
    <ec-divider style="width: 100%"></ec-divider>
    <template v-if="collapsible">
      <transition name="expand">
        <ec-flex v-if="isCollapsed" vertical alignItems="stretch" class="fb-content" :style="contentStyle">
          <slot></slot>
        </ec-flex>
      </transition>
    </template>
    <ec-flex v-else vertical alignItems="stretch" class="fb-content" :style="contentStyle">
      <slot></slot>
    </ec-flex>
  </ec-flex>
</template>
<script lang="ts" setup>
import { computed, ref } from "vue"

const props = withDefaults(
  defineProps<{
    title?: string
    titleWidth?: number
    titleMargin?: number
    leftRightPadding?: number
    topPadding?: number
    bottomPadding?: number
    collapsible?: boolean
  }>(),
  {
    title: "",
    titleMargin: 0,
    topPadding: 16,
    bottomPadding: 24,
    leftRightPadding: 16,
  }
)

const titleStyle = computed(() => {
  if (props.titleWidth) {
    return {
      width: `${props.titleWidth}px`,
      "margin-bottom": `${props.titleMargin}px`,
    }
  } else {
    return {
      width: "100%",
      "margin-bottom": `${props.titleMargin}px`,
    }
  }
})

const contentStyle = computed(() => {
  return {
    "padding-left": `${props.leftRightPadding}px`,
    "padding-right": `${props.leftRightPadding}px`,
    "padding-top": `${props.topPadding}px`,
    "padding-bottom": `${props.bottomPadding}px`,
    "box-sizing": "border-box",
    "flex-grow": "1",
  }
})

const isCollapsed = ref(props.collapsible)
const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value
}
</script>
<style scoped>
.fb-container {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  border-radius: 8px;
}
.fb-title-container {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  box-sizing: border-box;
}
.fb-title {
  min-height: 34px;
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

.fb-content {
  width: 100%; /* 确保内容区域宽度为100%，以便上方的div可以与其对齐 */
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}

.expand-enter-to,
.expand-leave-from {
  max-height: 1000px;
  opacity: 1;
}
</style>
